import * as React from 'react';
import AccessibleSVG from 'box-ui-elements/es/icons/accessible-svg';
import { bdlGray } from 'box-ui-elements/es/styles/variables';

type Props = {
  className?: string;
  color?: string;
  title?: string;
};

const CheckMark = ({ className = '', color = bdlGray, title }: Props) => (
  <AccessibleSVG
    className={className}
    height={16}
    title={title}
    viewBox="0 0 16 16"
    width={18}
  >
    <path
      d="M8.6 0c4.4 0 8 3.6 8 8s-3.6 8-8 8-8-3.6-8-8 3.6-8 8-8zm0 1c-3.9 0-7 3.1-7 7s3.1 7 7 7 7-3.1 7-7-3.1-7-7-7zM12 4.7c.2-.2.56-.273.76-.073.2.2.256.53.14.673l-4.7 5.8c-.2.2-.6.2-.8 0L4.7 8.3c-.2-.2-.2-.5 0-.7.2-.2.5-.2.7 0L7.7 10z"
      fill={color}
      fillRule="evenodd"
    />
  </AccessibleSVG>
);

export default CheckMark;
